export default Worker;



// WEBPACK FOOTER //
// ./src/helpers/worker.production.js